import { CustomerDTO } from './../models/customer.model';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { LinqFilterDTO,LinqFilterType,LinqPredicateDTO } from '../models/linqPredicate.model';
import { FilterService } from './filter.service';
import { DocumentDTO, DocumentListDTO, DocumentParameterDTO } from '../models/document.model';
import { DocumentFilterDTO } from '../models/documentFilter.model';
import { GlobalService } from './global.service';
import { DocumentXmlAttachmentDTO } from '../models/documentXmlAttachment.model';
import { SubjectToObject } from '../models/subjectToObject.model';
import { DocumentSectionalAttachmentDTO, DocumentSectionalAttachmentListDTO } from '../models/sectionalAttachments.model';
import { TransportDocumentDTO } from '../models/transportDocument.model';
import { OrderLineDTO } from '../models/order.model';
import { GenerateDocumentDTO } from '../models/generateDocument.model';
import { TransformDocumentDTO } from '../models/transformDocument.model';
import { FattureBolliFilterDTO, FattureBolliList, FattureBolliQuarter, FattureBolliRettificatoDTO } from '../models/documentBolli.model';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class DocumentService {

  constructor(private http: HttpClient, private filterService: FilterService, private authService: AuthService) {
  }

  getAllDocuments(linqPredicate: Array<LinqPredicateDTO> = null): Promise<Array<DocumentListDTO>> {

    if (linqPredicate == null || linqPredicate == undefined)
      linqPredicate = new Array<LinqPredicateDTO>();

    let fk_companyPredicate: Array<LinqPredicateDTO> = this.filterService.getCompanyHierarchyFilter("FK_Company");

    //Lo accoda agli eventuali filtri che arrivano come parametri
    let linqPredicates: Array<LinqPredicateDTO> = fk_companyPredicate.concat(linqPredicate);

    return this.http.post<Array<DocumentListDTO>>(environment.apiFullUrl + '/Document/GetAll', linqPredicates).toPromise();
  }

  getAllFilteredDocuments(documentFilter: LinqPredicateDTO[], isAllDocuments: boolean): Promise<Array<DocumentListDTO>> {
    let url = environment.apiFullUrl + '/Document/GetAllFilteredDocuments/' + isAllDocuments;
    return this.http.post<Array<DocumentListDTO>>(url, documentFilter).toPromise();
  }

  GetFilteredDocumentBolli(fattureBolliFilter: FattureBolliFilterDTO): Promise<Array<FattureBolliList>> {

    if (fattureBolliFilter == null)
    return;

  let filters = new Array<LinqPredicateDTO>();
    // Filtro Company
    let filtersCompany: LinqPredicateDTO = new LinqPredicateDTO();
    filtersCompany.PropertyFilters = new Array<LinqFilterDTO>();
    filtersCompany.PropertyFilters.push(LinqFilterDTO.createFilter("FK_Company", fattureBolliFilter.FK_Company, LinqFilterType.Equal));
    filters.push(filtersCompany);

    // Filtro Anno
    let filterAnno: LinqPredicateDTO = new LinqPredicateDTO();
    filterAnno.PropertyFilters = new Array<LinqFilterDTO>();
    filterAnno.PropertyFilters.push(LinqFilterDTO.createFilter("Anno", fattureBolliFilter.Anno, LinqFilterType.Equal));
    filters.push(filterAnno);


    if (fattureBolliFilter.Trimestre!=undefined){
    // Filtro trimestre 
    let filterTrimestre: LinqPredicateDTO = new LinqPredicateDTO();
    filterTrimestre.PropertyFilters = new Array<LinqFilterDTO>();
    filterTrimestre.PropertyFilters.push(LinqFilterDTO.createFilter("Trimestre", fattureBolliFilter.Trimestre, LinqFilterType.Equal));
    filters.push(filterTrimestre);
  }
    //Filtro tipo Bollo
    if (fattureBolliFilter.BolloRettificato!=undefined){
    if (fattureBolliFilter.BolloRettificato<3){
      let filterREttificato: LinqPredicateDTO = new LinqPredicateDTO();
      filterREttificato.PropertyFilters = new Array<LinqFilterDTO>();
      filterREttificato.PropertyFilters.push(LinqFilterDTO.createFilter("IsBollo",fattureBolliFilter.BolloRettificato==2? 0:1, LinqFilterType.Equal));
      filters.push(filterREttificato);
    }
  }

    let url = environment.apiFullUrl + '/Document/GetFilteredDocumentBolli';
    return this.http.post<Array<FattureBolliList>>(url, filters).toPromise();
  }

  GetFilteredDocumentBolliQuarter(fattureBolliFilter: FattureBolliFilterDTO): Promise<Array<FattureBolliQuarter>> {

    if (fattureBolliFilter == null)
    return;

    let filters = new Array<LinqPredicateDTO>();
   
  // Filtro Company
    let filtersCompany: LinqPredicateDTO = new LinqPredicateDTO();
    filtersCompany.PropertyFilters = new Array<LinqFilterDTO>();
    filtersCompany.PropertyFilters.push(LinqFilterDTO.createFilter("FK_Company", fattureBolliFilter.FK_Company, LinqFilterType.Equal));
    filters.push(filtersCompany);

    // Filtro Anno
    let filterAnno: LinqPredicateDTO = new LinqPredicateDTO();
    filterAnno.PropertyFilters = new Array<LinqFilterDTO>();
    filterAnno.PropertyFilters.push(LinqFilterDTO.createFilter("Anno", fattureBolliFilter.Anno, LinqFilterType.Equal));
    filters.push(filterAnno);

    let url = environment.apiFullUrl + '/Document/GetFilteredDocumentBolliQuarter';
    return this.http.post<Array<FattureBolliQuarter>>(url, filters).toPromise();
  }

  getDocumentByID(id: number): Promise<DocumentDTO> {
    return this.http.get<DocumentDTO>(environment.apiFullUrl + '/Document/' + id).toPromise();
  }
 
  saveRettifica(documents: Array<FattureBolliRettificatoDTO>): Promise<any> {
    let url = environment.apiFullUrl + '/Document/SetDocumentBolliRettifica';

    return this.http.post<any>(url,documents).toPromise();
  }
  

  
  RF19DocumentCheckLimit(document: DocumentDTO, accountID: number): Promise<any> {    
    //return this.http.get<any>(environment.apiFullUrl + '/Document/RF19DocumentCheckLimitget/1');    
    //return this.http.post<any>(environment.apiFullUrl + '/Document/RF19DocumentCheckLimit', document);    
    if (accountID == null) { 
      accountID = 0;
    }

    return this.http.post<DocumentDTO>(environment.apiFullUrl + '/Document/RF19DocumentCheckLimit/' + accountID, document).toPromise();    
  }
  

  saveDocument(document: DocumentDTO, account: number = null, ignoreValidation: boolean = false): Promise<any> {
    let route: any;
    if (account == null) {
      route = environment.apiFullUrl + '/Document/0';
    } else {
      route = environment.apiFullUrl + '/Document/' + account;
    }
    route += '/' + ignoreValidation;
    return this.http.post<any>(route, document).toPromise();
  }

  deleteDocument(id: number): Promise<any> {
    return this.http.delete<any>(environment.apiFullUrl + '/Document/' + id).toPromise();
  }

  setDisableStatus(id: number, disableStatus: boolean): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + '/Document/' + id + '/disablestatus/' + disableStatus).toPromise();
  }

  getIdentifier(documentParameters: DocumentParameterDTO): Promise<DocumentParameterDTO> {    
    return this.http.post<DocumentParameterDTO>(environment.apiFullUrl + '/Document/GetIdentifier', documentParameters).toPromise();    
  }

  calculateDocument(document: DocumentDTO): Promise<DocumentDTO> {
    return this.http.post<DocumentDTO>(environment.apiFullUrl + '/Document/CalculateDocument', document).toPromise();
  }

  saveDocumentFilter(documentFilter: DocumentFilterDTO): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + '/Document/SaveDocumentFilter', documentFilter).toPromise()
  }

  getDocumentFilterByCompanyId(fk_company: number): Promise<DocumentFilterDTO> {
    return this.http.get<DocumentFilterDTO>(environment.apiFullUrl + '/Document/GetDocumentFilterByCompanyId/' + fk_company).toPromise();
  }

  vatSeparation(isVATSeparation: boolean, document: DocumentDTO): Promise<DocumentDTO> {
    return this.http.post<DocumentDTO>(environment.apiFullUrl + '/Document/VATSeparation/' + isVATSeparation, document).toPromise();
  }

  sendDocumentMail(document: DocumentDTO, recipientMail: string, fk_company: number,fk_templateSelected: number): Promise<any> {
    var Maillist= btoa(recipientMail)+GlobalService.generateRandomString(8) 
    return this.http.post<DocumentFilterDTO>(environment.apiFullUrl + '/Document/SendDocumentMail/' +Maillist+ "/" + fk_company +"/"+ fk_templateSelected, document).toPromise();
  }

  getSubjectTo(documentType: number): Promise<Array<SubjectToObject>> {
    return this.http.get<Array<SubjectToObject>>(environment.apiFullUrl + '/Document/GetSubjectTo/' + documentType).toPromise();
  }

  getDocumentAttachments(id: number): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + '/Document/GetDocumentAttachments/' + id).toPromise();
  }

  uploadAttachment(newAttachment: DocumentXmlAttachmentDTO): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + '/Document/UploadAttachment', newAttachment).toPromise();
  }

  deleteAttachment(id: number): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + '/Document/DeleteAttachment/' + id).toPromise();
  }

  downloadAttachment(id: number) : Promise<any>{
    //let url = environment.apiFullUrl + "/Document/DownloadAttachment/" + id;
    //window.open(url, '_blank');
    let HTTPOptions: Object = {
      responseType: 'json'
    }
    return this.http.get<any>(environment.apiFullUrl + '/Document/DownloadAttachment/'+ id, HTTPOptions).toPromise();


  }

  getAdvancedExpenses(): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + "/Document/GetAdvanceExpenses").toPromise();
  }

  getCashDeskType(): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + "/Document/GetCashDeskType").toPromise();
  }

  getWithHoldingType(): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + "/Document/GetWithHoldingType").toPromise();
  }

  getNature(): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + '/Document/GetNature').toPromise();
  }

  getAllSectionalAttachments(fk_company: number): Promise<DocumentSectionalAttachmentListDTO[]> {
    return this.http.get<any>(environment.apiFullUrl + '/Document/GetAllSectionalAttachments/' + fk_company).toPromise();
  }

  downloadSectionalAttachment(id: number) {
    let url = environment.apiFullUrl + "/Document/DownloadSectionalAttachment/" + id;
    window.open(url, '_blank');
  }

  deleteSectionalAttachment(id: number): Promise<any> {
    return this.http.delete<any>(environment.apiFullUrl + '/Document/DeleteSectionalAttachment/' + id).toPromise();
  }

  uploadSectionalAttachment(attachment: DocumentSectionalAttachmentDTO) {
    return this.http.post<any>(environment.apiFullUrl + '/Document/UploadSectionalAttachment', attachment).toPromise();
  }

  getTransportTerms() {
    return this.http.get<any>(environment.apiFullUrl + '/Document/GetTransportTerms').toPromise();
  }

  deleteAllDocuments(fk_company: number) {
    return this.http.delete<any>(environment.apiFullUrl + '/Document/DeleteAllDocuments/' + fk_company).toPromise();
  }

  getCurrency() {
    return this.http.get<any>(environment.apiFullUrl + '/Document/GetCurrency').toPromise();
  }

  getLite(id: number): Promise<DocumentListDTO> {
    return this.http.get<any>(environment.apiFullUrl + '/Document/GetLite/' + id).toPromise();
  }

  updateIDsdiFEDocuments(ID: number, newIdSdiFE: string) {
    return this.http.get<any>(environment.apiFullUrl + '/Document/UpdateIDsdiFEDocuments/' + ID + '/' + newIdSdiFE).toPromise();
  }

  generateDocumentFromDDT(dto: GenerateDocumentDTO) {
    return this.http.post<any>(environment.apiFullUrl + '/Document/GenerateDocumentFromDDT', dto).toPromise();
  }

  generateDocumentFromOrderLines(dto: GenerateDocumentDTO) {
    return this.http.post<any>(environment.apiFullUrl + '/Document/GenerateDocumentFromOrderLines', dto).toPromise();
  }

  transformDocument(dto: TransformDocumentDTO) {
    return this.http.post<any>(environment.apiFullUrl + '/Document/TransformDocument', dto).toPromise();
  }

  getLastInvoiceDate(dto: DocumentParameterDTO) {
    return this.http.post<any>(environment.apiFullUrl + '/Document/GetLastInvoiceDate', dto).toPromise();
  }

  CheckIdentifier(dto: DocumentParameterDTO) {
    return this.http.post<any>(environment.apiFullUrl + '/Document/CheckIdentifier', dto).toPromise();
  }
}
